import { render } from "./TermsOfUsePage.vue?vue&type=template&id=b0a2cc54&scoped=true"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=ts"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-b0a2cc54"

export default script